// @flow

import React from 'react';

/**
 * SSRContext
 */
export const SSRContext = React.createContext(null);
